import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import DeleteModal from '../../Components/Common/DeleteModal';
import {toggleDeleteTableItemModal} from '../../slices/modals/reducer';
import { deleteItem } from '../../slices/folder/thunk';

function DeleteTableItemModal() {
  const dispatch = useDispatch();
  const selectDeleteModal = createSelector((state) => state.Modal, (state) => state.deleteTableItemModal);
  const deleteModal = useSelector(selectDeleteModal);
  const selectState = createSelector(state => state.Folder, state => state.selectedTableItem);
  const selectedTableItem = useSelector(selectState);

  function removeItem() {
    dispatch(deleteItem(selectedTableItem));
    dispatch(toggleDeleteTableItemModal());
  }
  return (
    <DeleteModal show={deleteModal} onCloseClick={() => {dispatch(toggleDeleteTableItemModal())}} onDeleteClick={removeItem} />
  )
}

export default DeleteTableItemModal;
